import { auth } from "~/lib/firebase";
import type { User } from "firebase/auth";

/**
 * Resolves once Firebase has finished reading persisted auth state.
 * Singleton promise survives React StrictMode remounts in dev.
 */
let authReadyPromise: Promise<void> | null = null;

export function waitForAuthReady(): Promise<void> {
  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      const unsubscribe = auth.onAuthStateChanged(() => {
        unsubscribe();
        resolve();
      });
    });
  }
  return authReadyPromise;
}

/** Use in route loaders instead of reading auth.currentUser synchronously on reload. */
export async function getReadyAuthUser(): Promise<User | null> {
  await waitForAuthReady();
  return auth.currentUser;
}
